import React, { FC, ReactNode } from 'react';
import SrcSet from '../../../../../components/src-set/src-set';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';
import { WidgetArticleInterface } from 'modules/shared/widgets/components/widget-articles/interfaces/widget-article.interface';

import './widget-article.scss';

type WidgetArticleProps = WidgetArticleInterface;

const WidgetArticle: FC<WidgetArticleProps> = ({
    id,
    url,
    title,
    lead,
    target,
    modifiedImg,
    isMobile,
    isSponsored,
    dsaurl,
    dsaText
}) => {
    const renderImage = (): ReactNode => {
        if (typeof modifiedImg === 'string') {
            return (
                <img
                    className="w-article__image"
                    src={modifiedImg}
                    alt={title}
                    loading="lazy"
                />
            );
        }

        return (
            <SrcSet
                className="w-article__image"
                images={modifiedImg}
                alt={title}
                lazyLoad={true}
                isMobile={isMobile}
            />
        );
    };

    return (
        <a
            className="w-article"
            target={target}
            href={url}
            id={id}
        >
            {isSponsored && (
                <div className="w-article__sponsored">
                    {dsaText || 'Materiał sponsorowany'}
                    {dsaurl && (
                        <a
                            className="w-article__icon"
                            href={dsaurl}
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOOPENER_NOREFERRER}
                            aria-label="Info"
                        >
                            ⓘ
                        </a>
                    )}
                </div>
            )}
            {renderImage()}
            <h3 className="w-article__title">
                {title}
            </h3>
            <p
                className="w-article__text"
                dangerouslySetInnerHTML={{ __html: lead }}
            />
            <span className="w-article__link">
                Czytaj dalej
            </span>
        </a>
    );
};

export default WidgetArticle;
